module.exports = __webpack_public_path__ + "static/img/zeta_template_10.3984681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_10.png
// module id = YFOG
// module chunks = 1